module.exports = __webpack_public_path__ + "static/media/400046_01.4bdf2f66.png";